import { render } from "./SignUpRemote.vue?vue&type=template&id=7e56ffee&scoped=true&ts=true"
import script from "./SignUpRemote.vue?vue&type=script&lang=ts"
export * from "./SignUpRemote.vue?vue&type=script&lang=ts"

import "./SignUpRemote.vue?vue&type=style&index=0&id=7e56ffee&scoped=true&lang=css"

import exportComponent from "/Users/pontustengroth/Desktop/git/shipd/apps/shipd-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e56ffee"]])

export default __exports__